import React from 'react';
import { lazyAfterPaint } from 'react-loosely-lazy';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/index.tsx';
import Placeholder from '@atlassian/jira-placeholder';
import { ERROR_REPORTING_PACKAGE_NAME } from './common/constants';
import type { IssueTypesAddModal as IssueTypesAddModalType } from './ui/index.tsx';
import type { Props as IssueTypesAddModalProps } from './ui/main.tsx';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyIssueTypesAddModal = lazyAfterPaint<typeof IssueTypesAddModalType>(
	() =>
		import(/* webpackChunkName: "async-admin-pages-issue-types-add-modal" */ './ui/index.tsx').then(
			(module) => module.IssueTypesAddModal,
		),
	{ ssr: false },
);

export const IssueTypesAddModal = (props: IssueTypesAddModalProps) => (
	<JSErrorBoundary
		id="issueTypesAddModalAsync"
		packageName={ERROR_REPORTING_PACKAGE_NAME}
		teamName="morphinecake"
		fallback={props.isOpen ? 'flag' : 'unmount'}
		sendToPrivacyUnsafeSplunk
	>
		<Placeholder name="issue-types-add-modal" fallback={null}>
			<LazyIssueTypesAddModal {...props} />
		</Placeholder>
	</JSErrorBoundary>
);
